import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  align: 'center',
  shrink: 0,
  spacing: 10,
  justify: 'space-between',
})`
  margin: 0;
  width: 100%;
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;

  & .is_hover_only {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    & .is_hover_only {
      visibility: visible;
    }
  }
`;

export const Name = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px;
  margin-left: -5px;
  color: ${props => props.theme.colors.link};
  border: 1px dashed transparent;
  font-size: 14px;
  line-height: 28px;

  & > div {
    margin-right: 8px;
  }
`;

export const DocumentIcon = styled(SVG.Document).attrs(
  props => ({
    width: '18px',
    height: '18px',
    stroke: props.theme.colors.link,
  }),
)``;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
`;
